define(["exports", "../LinterRule", "../l10n"], function (_exports, _LinterRule, _l10n) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.rule = void 0;
  _LinterRule = _interopRequireDefault(_LinterRule);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "check-punctuation";
  const punctuationMarks = [".", ":", "!", "?"];
  const humanMarks = punctuationMarks.map(mark => "\"".concat(mark, "\"")).join(", ");
  const meta = {
    en: {
      description: "`p` elements should end with a punctuation mark.",
      howToFix: "Please make sure `p` elements end with one of: ".concat(humanMarks, ".")
    }
  }; // Fall back to english, if language is missing

  const lang = _l10n.lang in meta ? _l10n.lang : "en";
  /**
   * Runs linter rule.
   *
   * @param {Object} _ The ReSpec config.
   * @param  {Document} doc The document to be checked.
   * @return {import("../../core/LinterRule").LinterResult}
   */

  function lintingFunction(_, doc) {
    // Check string ends with one of ., !, ?, :, ], or is empty.
    const punctuatingRegExp = new RegExp("[".concat(punctuationMarks.join(""), "\\]]$|^ *$"), "m");
    const offendingElements = [...doc.querySelectorAll("p:not(#back-to-top)")].filter(elem => !punctuatingRegExp.test(elem.textContent.trim()));

    if (!offendingElements.length) {
      return;
    }

    return _objectSpread({
      name,
      offendingElements,
      occurrences: offendingElements.length
    }, meta[lang]);
  }

  const rule = new _LinterRule.default(name, lintingFunction);
  _exports.rule = rule;
});
//# sourceMappingURL=check-punctuation.js.map